<!-- =========================================================================================
    File Name: ChatNavbar.vue
    Description: Chat Application - Chat navbar
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div v-if="user != null" class="chat__header">
        <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
            <div class="relative flex mr-4">
              <feather-icon icon="MenuIcon" class="mr-4 cursor-pointer" v-if="isSidebarCollapsed" @click.stop="$emit('openContactsSidebar')" />
              <vs-chip :color="user.color_code" class="userAvatar"></vs-chip>
                <!-- <vs-avatar v-if="user.image" class="m-0 border-2 border-solid border-white" size="40px" :src="img_cdn+user.image"  />
                <vs-avatar v-else class="m-0 border-2 border-solid border-white" size="40px"   /> -->
                <!-- <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-success'"></div> -->
            </div>
            <h6 v-if="user.name">{{ user.name }} <span  style="font-size:12px;font-weight: normal;font-style: italic">{{user.location.name}}</span></h6>
            <vs-spacer></vs-spacer>
            <!-- <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning stroke-current': true}, 'w-6', 'h-6']" @click.stop="isPinnedLocal = !isPinnedLocal"></feather-icon> -->
        </vs-navbar>
    </div>
</template>

<script>
export default {
  props: {
    isSidebarCollapsed: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    data () {
      return {
        img_cdn: ''
      }
    }
    // isPinnedProp: {
    //   type: Boolean,
    //   required: true
    // },
    // isSidebarCollapsed: {
    //   type: Boolean,
    //   required: true
    // }
  },
  computed: {
    // isPinnedLocal: {
    //   get () {
    //     return this.isPinnedProp
    //   },
    //   set (val) {
    //     const chatData = this.$store.getters['chat/chatDataOfUser'](this.userId)
    //     if (chatData) {
    //       const payload = { id: this.userId, value: val }
    //       this.$store.dispatch('chat/toggleIsPinned', payload)
    //         .then(() => { this.$emit('toggleIsChatPinned', val) })
    //         .catch((err) => { console.error(err) })
    //     } else {
    //       this.$emit('toggleIsChatPinned', val)
    //     }
    //   }
    // },
    // userDetails () {
    //   return this.$store.getters['chat/contact'](this.userId)
    // },
    // getStatusColor () {
    //   return (isActiveUser) => {
    //     const userStatus = this.getUserStatus(isActiveUser)

    //     if (userStatus === 'online') {
    //       return 'success'
    //     } else if (userStatus === 'do not disturb') {
    //       return 'danger'
    //     } else if (userStatus === 'away') {
    //       return 'warning'
    //     } else {
    //       return 'grey'
    //     }
    //   }
    // }
  },
  methods: {
    // getUserStatus (isActiveUser) {
    //   return isActiveUser ? this.$store.state.AppActiveUser.status : this.userDetails.status
    // }
  },
  created () {
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
  }
}

</script>
<style>
.userAvatar{
  height: 32px;
  width: 32px;
}
</style>
